import React from 'react';
import {Form, FormGroup, ControlLabel, FormControl, Button, Modal} from 'react-bootstrap';
import PropTypes from 'prop-types';

class CongressFormModal extends React.Component{

    static contextTypes = { api:PropTypes.object, notifier: PropTypes.object };

    constructor( props ){
        super(props);
        if( !props.editing ) {
            this.state = {
                form: {
                    name:'',
                    year:null
                }
            };
        }
        else {
            this.state = {
                form: {
                    name: props.editing.name,
                    year:props.editing.year
                }
            };
        }
    }

    onFormChange = ({target})=>{
        if(target.name==='year') this.setState( { form: { ...this.state.form, [target.name]:Number.parseInt(target.value,10)}} );
        else this.setState( { form: { ...this.state.form, [target.name]:target.value}} );
    };

    getFormValue = ( name ) => { return this.state.form[name]? this.state.form[name]:'';};

    saveForm = ()=>{
        if( !this.state.form.name || !this.state.form.year ) return this.context.notifier.error('No has llenado todos los campos');

        const congress = { ...this.state.form };
        const finish = ()=>{
            if( this.props.didSave ) this.props.didSave();
            else if( this.props.onHide ) this.props.onHide();
        };
        if (this.props.editing) this.context.api.congresses.edit(this.props.editing.id, congress, '@Class.Congresses.Congress.edit' ).then(finish);
        else this.context.api.congresses.create( congress, '@Class.Congresses.Congress.create').then(finish);
    };

    render(){
        const { onHide } = this.props;
        return (
            <Modal show={true}
                onHide={ onHide }>
                <Modal.Header closeButton>
                    <Modal.Title>{this.props.editing? 'Editar congreso' : 'Añadir congreso'}</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Form className='CongressFormModal'>
                        <FormGroup>
                            <ControlLabel>Nombre:</ControlLabel>
                            <FormControl
                                autoFocus={true}
                                placeholder='Nombre del congreso'
                                name='name'
                                value={ this.getFormValue('name') }
                                onChange={this.onFormChange}
                                required/>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Año:</ControlLabel>
                            <FormControl
                                placeholder='Año del congreso'
                                name='year'
                                value={ this.getFormValue('year') }
                                onChange={this.onFormChange}
                                required/>
                        </FormGroup><br/>
                        <Button
                            bsStyle='danger'
                            onClick={this.props.onHide}
                            >Cancelar</Button>
                        <Button
                            bsStyle='success'
                            className='pull-right'
                            onClick={this.saveForm}
                            >Guardar</Button>
                    </Form>
                </Modal.Body>
            </Modal>
        );
    }
}

export default CongressFormModal;


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/Congresses/components/CongressFormModal/index.jsx